import { useCallback, useMemo } from 'react';

import { useDispatch } from 'react-redux';

import { ModalService } from 'ui-components/services/modal-service';

import { DocumentType } from '../../../../enums/document-type';
import { downloadDocument, printDocument } from '../../../../store/documents/documents.actions';
import { PrintLabelPrintWarningContainer } from '../../../print-label-print-warning-container';
import { buildDefaultPrintSetting } from '../../core/buildDefaultPrintSetting';
import { usePrintSettings } from '../../core/hooks';

export const useLabelDefaultPrintSettings = (fulfillmentIds, hasPrintedLabel) => {
  const printSettings = usePrintSettings(DocumentType.Label.printSettingKey);
  const dispatch = useDispatch();

  const dispatchLabelAction = useCallback(
    (labelAction) => {
      const dispatchAction = () => dispatch(labelAction);

      if (hasPrintedLabel) {
        ModalService.launchModal({
          component: PrintLabelPrintWarningContainer,
          props: {
            onYesClick: dispatchAction,
          },
        });
        return;
      }

      dispatchAction();
    },
    [dispatch, hasPrintedLabel],
  );

  const onDownload = useCallback(() => {
    dispatchLabelAction(downloadDocument(DocumentType.Label, fulfillmentIds));
  }, [dispatchLabelAction, fulfillmentIds]);

  const onPrint = useCallback(() => {
    dispatchLabelAction(printDocument(DocumentType.Label, fulfillmentIds, printSettings));
  }, [dispatchLabelAction, fulfillmentIds, printSettings]);

  return useMemo(() => buildDefaultPrintSetting(printSettings, onPrint, onDownload), [onDownload, onPrint, printSettings]);
};
